'use client' 
import { PrismicNextLink } from "@prismicio/next";
import { usePathname } from "next/navigation";
import { resolveRoute } from "../../prismicio";

/**
 * @typedef {import("@prismicio/client").Content.NavItemsSlice} NavItemsSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<NavItemsSlice>} NavItemsProps
 * @type {import("react").FC<NavItemsProps>}
 */
const NavItems = ({ slice, context }) => {
  const pathname = usePathname();

  const linkField = slice?.primary?.cta;
  let href = null;
  if (linkField) {
    if (linkField.link_type === "Document") {
      href = resolveRoute(linkField);
    } else if (linkField.url) {
      href = linkField.url;
    }
  }

  const isActive = Boolean(href) && (pathname === href || (href !== "/" && pathname.startsWith(href)));
  const handleClick = () => {
    // Close mobile menu if the closeMenu function is available in context
    if (context?.closeMenu) {
      context.closeMenu();
    }
  };

  return (
    <li
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="header-menu-item w-full border-b-1 border-moyam-orange pb-3 md:border-0 md:pb-0"
    >
      <PrismicNextLink 
        field={slice.primary.cta} 
        className={`flex flex-row justify-between items-center ${isActive ? "no-underline md:underline underline-moyam!" : ""}`}
        onClick={handleClick}>
        {slice.primary.cta.text}
        <img src="/img/arrow-right-orange.svg" alt="Arrow Right" className="w-4 h-4 block md:hidden" />
      </PrismicNextLink>
    </li>
  );
};

export default NavItems;
